import axios from 'axios';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

const useApi = () => {
  const token = useAuthHeader()?.substring(7);
  const apiClient = axios.create();

  apiClient.interceptors.request.use(async (config) => {

    config.headers.Authorization = `Bearer ${token}`;
    config.headers['Content-Type'] = `application/json`;
    // config.headers['Access-Control-Allow-Origin'] = '*';
    // config.headers['Access-Control-Allow-Credentials'] = 'true'


    return config;
  });

  return apiClient;
};

export default useApi;
